import { videos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';
import { Link } from 'react-router-dom';

export default function LatestUpdates() {
  const newVideos = videos.filter((v) => v.isNew).slice(0, 8);

  return (
    <section className="py-14 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                最新更新
              </h2>
              <p className="text-sm text-foreground-500 mt-1">每日更新，精彩不错过</p>
            </div>
            <Link
              to="/category/dianying"
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
            >
              查看更多
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 animate-fade-in-up" data-product-shop="">
            {newVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}